import ReactGA from 'react-ga4';

// Initialization happens once in jsx/App.jsx — this just re-exports the same
// instance so marinetools components don't import react-ga4 directly.
export default ReactGA;
